const SMS_SESSION_STORAGE_KEY = "xan.staff-auth.sms-session";

function getSmsSessionStorage(): Storage | null {
  if (typeof window === "undefined") {
    return null;
  }
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function isRecoverableSmsStorageError(error: unknown): boolean {
  return (
    error instanceof SyntaxError ||
    (typeof DOMException !== "undefined" && error instanceof DOMException)
  );
}

export function removeStoredSmsSession() {
  const storage = getSmsSessionStorage();
  if (!storage) {
    return;
  }
  try {
    storage.removeItem(SMS_SESSION_STORAGE_KEY);
  } catch (error) {
    if (!isRecoverableSmsStorageError(error)) {
      throw error;
    }
  }
}
